class FeaturedCollectionTabs extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    
    // Wait for Tabby to be ready before initializing
    whenReady("Tabby", (Tabby) => {
      this.initializeTabs(Tabby);
    });
  }

  initializeTabs(Tabby) {
    // Find all tab containers within this component
    const tabContainers = this.querySelectorAll('[data-tabby]');
    
    tabContainers.forEach(container => {
        const tabbyId = container.getAttribute('id');
      // Initialize Tabby on each container
      new Tabby(`#${tabbyId}`);
    });

    // Add click handlers for data-tabby-href elements
    this.addCollectionLinkHandlers();

    // Dispatch a custom event to notify that tabs are ready
    this.dispatchEvent(new CustomEvent('tabsReady', {
      bubbles: true,
      detail: { tabContainers: tabContainers.length }
    }));
  }

  // Add click handlers for collection links
  addCollectionLinkHandlers() {
    const collectionLinks = this.querySelectorAll('[data-tabby-href]');
    
    collectionLinks.forEach(link => {
      link.addEventListener('click', (event) => {
        // Prevent the default tab behavior and Tabby from processing this click
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        
        // Get the collection URL from the data attribute
        const collectionUrl = link.getAttribute('data-tabby-href');
        
        if (collectionUrl) {
          // Navigate to the collection page
          window.location.href = collectionUrl;
        }
      }, true); // Use capture phase to ensure our handler runs first
    });
  }

  // Method to manually reinitialize tabs if needed
  reinitializeTabs() {
    whenReady("Tabby", (Tabby) => {
      this.initializeTabs(Tabby);
    });
  }
}

// Register the web component
customElements.define('featured-collection-tabs', FeaturedCollectionTabs);
